import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { routing } from '../app.routes';
import { TraceNodeComponent } from './trace-node/trace-node.component';
import { TraceManagementComponent } from './trace-management.component';
import { TraceNodeListComponent } from './trace-node-list/trace-node-list.component';
import { TraceViewerComponent } from './viewer/entries/trace-viewer.component';
import { TraceService } from './core/services/trace.service';
import { BzTabModule } from '../shared/components/tab/tab.module';
import { ViewerDetailComponent } from './viewer/detail/viewer-detail.component';
import { ViewerEntriesReloadComponent } from './viewer/reload/viewer-reload-entries.component';
import { SharedModule } from '../shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TraceManagementStateService } from 'app/trace-management/trace-manageent.state.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalViewerDetailComponent } from './viewer/modal-detail/modal-viewer-detail.component';
import { CategoriesUppercase } from './viewer/entries/trace-viewer.pipe';
import { TraceViewerManagementComponent } from './trace-viewer-management/trace-viewer-management.component';
import { TraceServiceImprovement } from './core/services/trace-improvement.service';
import { FiltersComponent } from './trace-viewer-management/filters/filters.component';
import { TableComponent } from './trace-viewer-management/table/table.component';
import { DetailComponent } from './trace-viewer-management/detail/detail.component';
import { CustomDatePipe } from './trace-viewer-management/pipe/custom-date.pipe';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}


@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    TooltipModule.forRoot(),
    HttpClientModule,
    routing,
    CommonModule,
    FormsModule,
    BzTabModule,
    SharedModule
  ],
  declarations: [
    TraceManagementComponent,
    TraceNodeListComponent,
    TraceNodeComponent,
    TraceViewerComponent,
    ViewerDetailComponent,
    ViewerEntriesReloadComponent,
    ModalViewerDetailComponent,
    CategoriesUppercase,
    TraceViewerManagementComponent,
    FiltersComponent,
    TableComponent,
    DetailComponent,
    CustomDatePipe
  ],
  exports: [
    TraceManagementComponent,
    TraceNodeListComponent,
    ModalViewerDetailComponent
  ],
  providers: [
    TraceService,
    TraceServiceImprovement,
    TraceManagementStateService
  ]
})
export class TraceManagementModule { }
